import { useState } from "react";
import {
  ChevronDown,
  ChevronRight,
} from "react-bootstrap-icons";

export default function SettingsCard({
  icon,
  title,
  description,
  className = "",
  iconClassName = "",
  defaultOpen = false,
  children,
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <section
      className={`settings-card ${
        isOpen ? "settings-card-open" : "settings-card-collapsed"
      } ${className}`.trim()}
    >
      <button
        type="button"
        className="settings-card-toggle"
        onClick={() => setIsOpen((current) => !current)}
        aria-expanded={isOpen}
      >
        <div className="settings-card-info">
          <div className={`settings-icon ${iconClassName}`.trim()}>
            {icon}
          </div>

          <div>
            <h2>{title}</h2>
            <p>{description}</p>
          </div>
        </div>

        <span className="settings-card-chevron">
          {isOpen ? <ChevronDown /> : <ChevronRight />}
        </span>
      </button>

      {isOpen && (
        <div className="settings-card-content">
          {children}
        </div>
      )}
    </section>
  );
}